import { ApiResponse } from 'apisauce';
import { ErrorResponse } from '../../../lib/basicRepository';
import { PaginatedResponse } from '../../../types/request.types';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import {
  BatchBusinessPoliciesBody,
  BusinessPoliciesBatchSelection,
  BusinessPolicyDTO,
  BusinessPolicyVoucherDTO,
  CopyBusinessPolicyDTO,
  FindAvailableVouchersParams,
  FindBusinessPoliciesParams,
  GetBusinessPolicyDTO,
} from './businessPolicies.types';

const rootPath = 'business-policies';
const vouchersRootPath = 'business-policy-vouchers';

export const findBusinessPolicies = (
  params: FindBusinessPoliciesParams,
  signal?: AbortSignal,
): Promise<ApiResponse<PaginatedResponse<GetBusinessPolicyDTO>>> =>
  restApi.get<PaginatedResponse<GetBusinessPolicyDTO>>(`${rootPath}`, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });

export const getBusinessPolicy = (id: string) =>
  restApi.get<BusinessPolicyDTO, ErrorResponse>(`${rootPath}/${id}`);

export const createBusinessPolicy = (dto: BusinessPolicyDTO) =>
  restApi.post<BusinessPolicyDTO, ErrorResponse>(rootPath, dto);

export const updateBusinessPolicy = ({ id, dto }: { id: string; dto: BusinessPolicyDTO }) =>
  restApi.patch<BusinessPolicyDTO, ErrorResponse>(`${rootPath}/${id}`, dto);

export const copyBusinessPolicy = ({ id, body }: { id: string; body: CopyBusinessPolicyDTO }) =>
  restApi.post<BusinessPolicyDTO, ErrorResponse>(`${rootPath}/${id}/copy`, body);

export const toggleBusinessPolicy = ({ id }: { id: string }) =>
  restApi.patch<unknown, ErrorResponse>(`${rootPath}/${id}/toggle`);

export const deleteBusinessPolicy = (id: string) =>
  restApi.delete<unknown, ErrorResponse>(`${rootPath}/${id}`);

export const batchUpdateBusinessPolicies = (body: BatchBusinessPoliciesBody) =>
  restApi.patch<void, ErrorResponse>(`${rootPath}/batch`, body);

export const batchDeleteBusinessPolicies = (selection: BusinessPoliciesBatchSelection) =>
  restApi.delete<void, ErrorResponse>(`${rootPath}/batch`, {}, { data: selection });

export const findAvailableVouchers = (
  params: FindAvailableVouchersParams,
  signal?: AbortSignal,
): Promise<ApiResponse<PaginatedResponse<BusinessPolicyVoucherDTO>>> =>
  restApi.get<PaginatedResponse<BusinessPolicyVoucherDTO>>(
    `${vouchersRootPath}/available`,
    params,
    { cancelToken: cancelTokenFromSignal(signal)?.token },
  );
